import api from "./axios"; // axios déjà configuré avec baseURL

export const getUtilisateurs = () => api.get("/utilisateurs");
export const getUtilisateurById = (id) => api.get(`/utilisateurs/${id}`);

export const createUtilisateur = async (data) => {
  try {
    const res = await api.post("/utilisateurs", data);
    console.log("Utilisateur créé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
  }
};

export const updateUtilisateur = async (id, data) => {
  try {
    const res = await api.put(`/utilisateurs/${id}`, data);
    console.log("Utilisateur mis à jour :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la mise à jour :", ex.response ? ex.response.data : ex);
  }
};

export const deleteUtilisateur = async (id) => {
  try {
    const res = await api.delete(`/utilisateurs/${id}`);
    console.log("Utilisateur supprimé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la suppression :", ex.response ? ex.response.data : ex);
  }
};
